// Editor.js
import EditorJS from '@editorjs/editorjs';
window.EditorJS = EditorJS;

import Header from '@editorjs/header';
window.Header = Header;

import ImageTool from '@editorjs/image';
window.ImageTool = ImageTool;

import NestedList from '@editorjs/nested-list';
window.NestedList = NestedList;

import Quote from '@editorjs/quote';
window.Quote = Quote;

import Marker from '@editorjs/marker';
window.Marker = Marker;

import Delimiter from '@editorjs/delimiter';
window.Delimiter = Delimiter;

import CodeTool from '@editorjs/code';
window.CodeTool = CodeTool;

import Embed from '@editorjs/embed';
window.Embed = Embed;

import InlineCode from '@editorjs/inline-code';
window.InlineCode = InlineCode;

import Table from '@editorjs/table';
window.Table = Table;

import AlignmentTuneTool from 'editorjs-text-alignment-blocktune';
window.AlignmentTuneTool = AlignmentTuneTool;

import AttachesTool from '@editorjs/attaches';
window.AttachesTool = AttachesTool;

import Hyperlink from "/src/build/lib/editorjs/hyperlink.js";
window.Hyperlink = Hyperlink;

import VideoTool from "/src/build/lib/editorjs/video.js";
window.VideoTool = VideoTool;

import ImageGallery from "/src/build/lib/editorjs/gallery.js";
window.ImageGallery = ImageGallery;